import {EgTnlBucket} from '@expediagroup/egtnl-bucket-web';

let egtnlEvaluator;

const egtnlWrapper = {
    /**
     * returns egtnl experiment evaluator after initialising egtnl bucket with bucket evaluation data
     * @param {object} bucketEvaluationData
     * @returns {object} egtnlEvaluator
     */
    initialiseEgtnlBucket(bucketEvaluationData) {
        const callbacks = {
            onInvalidPayload: (error) =>
                console.log('Error egcs: Invalid Payload', error), //
            onPublishError: (error) =>
                console.log('Error egcs: Publish function', error),
            onFetchError: (error) => console.log('Error egcs: Fetching', error),
        };

        const bucketConfig = EgTnlBucket.bucketConfig(bucketEvaluationData, [
            EgTnlBucket.egLogger(callbacks),
        ]);

        EgTnlBucket.initialize(bucketConfig);

        egtnlEvaluator = EgTnlBucket.evaluator();
        return egtnlEvaluator;
    },

    /**
     * returns egtnl experiment object & logs exposure
     * @param {string} testName
     * @returns {object} egtnlBucket
     */
    evaluateExperimentAndLog(testName) {
        return egtnlEvaluator.evaluateExperimentAndLog(testName);
    },

    /**
     * returns egtnl experiment object
     * @param {string} testName
     * @returns {object} egtnlBucket
     */
    evaluateExperiment(testName) {
        return egtnlEvaluator.evaluateExperiment(testName);
    },

    /**
     * log the test and return boolean specifying if the test is active
     * @param {string} testName
     * @returns {boolean} egtnlTestEnabled
     */
    isEgtnlTestEnabledAndLog(testName) {
        if (!testName) return false;
        return this.evaluateExperimentAndLog(testName).value > 0;
    },

    /**
     * Logs an already evaluated experiment
     * returns array of promises to log the experiment as a result of calling evaluateExperiment()
     * @returns Promise<void[]> - array of promises to log
     * @param evaluationData
     */
    logExperiment(evaluationData) {
        return egtnlEvaluator.logExperiment(evaluationData);
    },
};

export default egtnlWrapper;
